import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { APIPATH } from '../App';

function RequireAuth({ children }: { children: JSX.Element }) {
    const [checking, setChecking] = useState(true);
    const [isAuthed, setIsAuthed] = useState(false);
    const location = useLocation();

    useEffect(() => {
        let cancelled = false;

        (async () => {
            try {
                const res = await fetch(`${APIPATH}/Auth/currentUser`, {
                    credentials: "include", 
                });

                if (!cancelled) {
                    setIsAuthed(res.ok);
                }
            } catch {
                if (!cancelled) {
                    setIsAuthed(false);
                }
            } finally {
                if (!cancelled) {
                    setChecking(false);
                }
            }
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    if (checking) {
        return <div className="main container py-4 mb-6">Checking session…</div>;
    }

    if (!isAuthed) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}

export default RequireAuth;
